module.exports = __webpack_public_path__ + "static/binary-1-2958a0f1d83aad282fb6da65e69cb493.png";